export default "__VITE_ASSET__BXXcguNV__"